import http from '@/services/http';

/**
 * Get the the order that pertains to the ticket number
 */
async function getTableTicket({ rootState }, { merchantLocationId, ticket }) {
  const sessionRoute = rootState.session.route;

  try {
    const partnerIdentification = sessionRoute.query?.pi || undefined;

    const requestPayload = {
      params: {
        pi: partnerIdentification,
        tn: ticket.ticketNumber
      }
    };

    const response = await http.get(`/cardfree-api/v1/pat/pay/${merchantLocationId}/tickets`, requestPayload);

    return response;
  }
  catch (error) {
    throw error;
  }
}

export { getTableTicket };
